<template>
	<div class="vn-form action-managment">
		<aside class="warning plan-note" role="note">
			<strong>پیش از شروع</strong>
			<ul>
				<li>برای هر برنامه شماره‌ی همراه نیروی اجرایی و کد مشتری را وارد کنید و با [+] به فهرست اضافه کنید.</li>
				<li>برای برنامه‌های زیاد از بارگذاری اکسل استفاده کنید؛ فقط با فایل نمونه و بدون تغییر سرستون‌ها.</li>
			</ul>
		</aside>
		<section class="vn-form-section">
			<header><span class="vn-step">۱</span><div><h2>زمان و نوع برنامه</h2><p>این تنظیمات روی همه‌ی برنامه‌های این مرحله اعمال می‌شود.</p></div></header>
			<div class="vn-form-grid">
				<div class="vn-field">
					<label for="plan-date">تاریخ اجرا</label>
					<input id="plan-date" type="text" :disabled="status" class="custom-input inputs" placeholder="انتخاب تاریخ" readonly />
					<date-picker v-model="dataPicker" clearable format="YYYY-MM-DDTHH:mm:00" display-format="jMMMM jD" custom-input="#plan-date" :disabled="status" />
				</div>
				<div class="vn-field">
					<label for="plan-type">نوع برنامه</label>
					<select id="plan-type" v-model="visitTypeSelected" class="form-select">
						<option :value="null" disabled>انتخاب کنید</option>
						<option v-for="visit in visitTypeList" :value="visit.id" :key="visit.id">{{ visit.verbose_name }}</option>
					</select>
				</div>
				<label class="vn-check"><input type="checkbox" v-model="status" />این برنامه تاریخ مشخصی برای اجرا ندارد</label>
				<label class="vn-check"><input type="checkbox" v-model="isLastDay" />ویزیت روز آخر</label>
			</div>
		</section>
		<section class="vn-form-section">
			<header><span class="vn-step">۲</span><div><h2>نیروی اجرایی و مشتری‌ها</h2><p>ردیف‌ها را دستی اضافه کنید یا فایل اکسل بارگذاری کنید.</p></div></header>
			<PickAction ref="rows" @sendPhoneNumber="getPhoneNumber" />
		</section>
		<div class="vn-form-actions">
				<span class="note" role="status">{{ summary }}</span>
				<button type="button" :disabled="checkEmpty || loading" class="accept" @click="continueProcess">{{ loading ? 'در حال ثبت…' : 'ثبت برنامه' }}</button>
			</div>
		<loading v-if="loading" />
	</div>
</template>
<script>
import PickAction from '../../components/pickAction/index.vue';
import Loading from '../../components/Loading/index.vue';

export default {
	components: {
		PickAction,
		Loading,
	},
	data() {
		return {
			dataPicker: '',
			phoneNumber: [],
			status: false,
			visitTypeList: [],
			visitTypeSelected: null,
			loading: false,
			isLastDay: false,
		};
	},
	mounted() {
		this.getVisitType();
	},
	computed: {
		checkEmpty() {
			return !(this.phoneNumber.length && this.visitTypeSelected !== null && (this.dataPicker !== '' || this.status === true));
		},
		// what is still missing, so a disabled button always explains itself
		summary() {
			if (!this.phoneNumber.length) return 'دست‌کم یک ردیف کامل (شماره و کد مشتری) لازم است.';
			if (this.visitTypeSelected === null) return 'نوع برنامه را انتخاب کنید.';
			if (this.dataPicker === '' && !this.status) return 'تاریخ اجرا را انتخاب کنید یا «بدون تاریخ» را بزنید.';
			return `${Number(this.phoneNumber.length).toLocaleString('fa-IR')} ویزیت ثبت می‌شود.`;
		},
	},
	methods: {
		getPhoneNumber(value) {
			this.phoneNumber = value;
		},
		async getVisitType() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.VISIT_TYPE + '?p=' + this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) this.visitTypeList = res.data.filter(item => item.is_active !== false);
		},
		async continueProcess() {
				if (this.checkEmpty || this.loading) return;
				this.loading = true;
				const actions = this.phoneNumber.map(row => ({ ...row, is_last_day: this.isLastDay }));
				const res = await this.$ApiServiceLayer.post(
					this.$PATH.RELATIVE_PATH.MULTI.CREATE_ACTION_PLAN + '?p=' + this.$STORE.state.userConfig.setProjectId,
					this.$PATH.SERVICE_NAME.AUTH,
					{
						project: this.$STORE.state.userConfig.setProjectId,
						actions,
						has_due_date: !this.status,
						due_date: this.dataPicker,
						visit_type: this.visitTypeSelected,
					},
				);
				this.loading = false;
				if (res.status !== 200) {
					this.$notify({ group: 'tc', type: 'error', text: 'برنامه ثبت نشد. ' + this.$ApiServiceLayer.getErrorMessage(res) });
					return;
				}
				// the server reports rows it could not match (unknown phone number or customer code)
				const failed = (res.data && res.data.errors) || [];
				const created = actions.length - failed.length;
				if (!failed.length) {
					this.$notify({ group: 'tc', type: 'success', text: `${Number(created).toLocaleString('fa-IR')} ویزیت ثبت شد.` });
					this.$router.push({ name: 'listActionPlan' });
					return;
				}
				this.$refs.rows.keepRejected(failed);
				this.$notify({
					group: 'tc',
					type: created ? 'warn' : 'error',
					text: created
						? `${Number(created).toLocaleString('fa-IR')} ویزیت ثبت شد؛ ${Number(failed.length).toLocaleString('fa-IR')} ردیف ثبت نشد و برای اصلاح در صفحه ماند.`
						: 'هیچ ردیفی ثبت نشد؛ شماره‌ها و کدها را بررسی کنید.',
				});
			},
			openLoading() {
			this.$refs.loading.open();
		},
	},
};
</script>
<style scoped>
.action-managment { max-width: 1100px; }
.plan-note { padding: 14px 18px; border: 1px solid #F2D48E; border-inline-start: 4px solid var(--amber-500); }
.plan-note strong { font-weight: 900; }
.plan-note ul { margin: 6px 0 0; padding-inline-start: 18px; font-size: 13px; color: var(--text-2); }
.plan-note li { list-style: disc; }
</style>
